import React, { useContext, useEffect, useState } from "react";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import Titulo from "../../Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import { Input } from "../../Input";
import { copy, deepCopy } from "../../../services/Functions";
import { ContainerRetiradaNoLocalContainer } from "./styles";
import { ToggleConfigurar } from "../../Toggle/ToggleConfigurar/ToggleConfigurar";
import Dropdown from "../../Dropdowns/Dropdown";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { Toggle } from "../../Toggle/Toggle";
import { cepMask } from "../../../services/Masks";
import { validateCep } from "../../../services/MasksValidations";
import { unmaskToNumbers } from "../../../services/Unmasks";

interface RetiradaNoLocalProps {
  configIn: "empresa" | "configuracoes";
}

const RetiradaNoLocal: React.FC<RetiradaNoLocalProps> = ({ configIn }) => {
  const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);
  const [novoCep, setNovoCep] = useState(configuracoes.dados_empresa.endereco.cep);

  const handleCepChange = (newValue) => {
    setNovoCep(newValue);

    const copia = copy(configuracoes);
    copia.frete.retirada_no_local.meu_cep.novo_cep = newValue;
    setConfiguracoes(copia);
  };

  useEffect(() => {
    const copia = copy(configuracoes);

    // Se ambos estiverem desativados, ativa o CEP do local como padrão
    if (!copia.frete.retirada_no_local.meu_cep.ativo && !copia.frete.retirada_no_local.por_cep.ativo) {
      copia.frete.retirada_no_local.meu_cep.ativo = true;
      setConfiguracoes(copia);
    }

    if (!configuracoes.frete.retirada_no_local.meu_cep.novo_cep) {
      const cepInicial = configuracoes.dados_empresa.endereco.cep;
      setNovoCep(cepInicial);
      copia.frete.retirada_no_local.meu_cep.novo_cep = cepInicial;
      setConfiguracoes(copia);
    } else {
      setNovoCep(configuracoes.frete.retirada_no_local.meu_cep.novo_cep);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dias = [
    "Domingo",
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sábado",
  ];

  const { theme } = useTheme();

  const [diasParaUso, setDiasParaUso] = useState<string[]>(
    dias.filter(
      (dia) =>
        !configuracoes.frete.retirada_no_local.intervalos.some((intervalo) =>
          intervalo.dias.includes(dia),
        ),
    ),
  );

  return (
    <>
      <ContainerRetiradaNoLocalContainer configIn={configIn} theme={theme}>
        {configIn === "empresa" && (
          <Titulo
            titulo="Retirada no local"
            subtitulo={"Selecione os dias e os horários de retirada"}
            flexDirection="column-reverse"
          />
        )}
        <div className="textoRetiradaLocal fonteTexto">
          Permita que clientes retirem pedidos diretamente com você.
          Ative a retirada local e defina dias e horários de atendimento. <br />
          É uma opção econômica e rápida para quem quer receber o pedido sem pagar frete.
        </div>
        <div className="flex">
          <label>
            <Toggle
              value={configuracoes.frete.retirada_no_local.meu_cep.ativo}
              onChange={(newValue) => {
                if (newValue) {
                  setConfiguracoes({
                    ...configuracoes,
                    frete: {
                      ...configuracoes.frete,
                      retirada_no_local: {
                        ...configuracoes.frete.retirada_no_local,
                        meu_cep: {
                          ...configuracoes.frete.retirada_no_local.meu_cep,
                          ativo: true,
                        },
                        por_cep: {
                          ...configuracoes.frete.retirada_no_local.por_cep,
                          ativo: false,
                        },
                      },
                    },
                  });
                } else {
                  // Não permite desativar se o outro também estiver desativado
                  if (!configuracoes.frete.retirada_no_local.por_cep.ativo) {
                    return; // Não faz nada, mantém ativo
                  }
                  setConfiguracoes({
                    ...configuracoes,
                    frete: {
                      ...configuracoes.frete,
                      retirada_no_local: {
                        ...configuracoes.frete.retirada_no_local,
                        meu_cep: {
                          ...configuracoes.frete.retirada_no_local.meu_cep,
                          ativo: false,
                        },
                      },
                    },
                  });
                }
              }}
            />
            <span className="fonteTexto">CEP do local</span>
          </label>

          {configuracoes.frete.retirada_no_local.meu_cep.ativo && (
            <div className="flex-inputs">
              <Input
                alignLabel="left"
                mask={{
                  mask: cepMask,
                  maskValidation: validateCep,
                  unmask: unmaskToNumbers,
                }}
                type={"text"}
                value={novoCep}
                placeholder={"99200-000"}
                onChange={handleCepChange}
              />
            </div>
          )}
        </div>

        <div className="flex">
          <label>
            <Toggle
              value={configuracoes.frete.retirada_no_local.por_cep.ativo}
              onChange={(newValue) => {
                if (newValue) {
                  setConfiguracoes({
                    ...configuracoes,
                    frete: {
                      ...configuracoes.frete,
                      retirada_no_local: {
                        ...configuracoes.frete.retirada_no_local,
                        por_cep: {
                          ...configuracoes.frete.retirada_no_local.por_cep,
                          ativo: true,
                        },
                        meu_cep: {
                          ...configuracoes.frete.retirada_no_local.meu_cep,
                          ativo: false,
                        },
                      },
                    },
                  });
                } else {
                  // Não permite desativar se o outro também estiver desativado
                  if (!configuracoes.frete.retirada_no_local.meu_cep.ativo) {
                    return; // Não faz nada, mantém ativo
                  }
                  setConfiguracoes({
                    ...configuracoes,
                    frete: {
                      ...configuracoes.frete,
                      retirada_no_local: {
                        ...configuracoes.frete.retirada_no_local,
                        por_cep: {
                          ...configuracoes.frete.retirada_no_local.por_cep,
                          ativo: false,
                        },
                      },
                    },
                  });
                }
              }}
            />
            <span className="fonteTexto">Definir faixa de CEP</span>
          </label>

          {configuracoes.frete.retirada_no_local.por_cep.ativo && (
            <div className="flex-inputs">
              <Input
                label="CEP - Início"
                alignLabel="left"
                type={"text"}
                mask={{
                  mask: cepMask,
                  maskValidation: validateCep,
                  unmask: unmaskToNumbers,
                }}
                value={configuracoes.frete.retirada_no_local.por_cep.cep_inicio}
                placeholder={"99200-000"}
                onChange={(newValue) => {
                  const copia = copy(configuracoes);
                  copia.frete.retirada_no_local.por_cep.cep_inicio = newValue;
                  setConfiguracoes(copia);
                }}
              />

              <Input
                label="CEP - Fim"
                alignLabel="left"
                type={"text"}
                value={configuracoes.frete.retirada_no_local.por_cep.cep_fim}
                placeholder={"99200-000"}
                mask={{
                  mask: cepMask,
                  maskValidation: validateCep,
                  unmask: unmaskToNumbers,
                }}
                onChange={(newValue) => {
                  const copia = copy(configuracoes);
                  copia.frete.retirada_no_local.por_cep.cep_fim = newValue;
                  setConfiguracoes(copia);
                }}
              />
            </div>
          )}
        </div>

        <div className="fonteSubtitulo tituloIntervalos">Horário de atendimento</div>
        <div className="dropdown">
          {configuracoes.frete.retirada_no_local.intervalos.map(
            (intervalo, indexIntervalo) => {
              return (
                <>
                  <div className="intervalos">
                    <div className="diasContainer fonteTexto">
                      <label className="fonteTexto">Dias da semana</label>
                      <div className="flexDias">
                        {dias.map((dia, indexDia) => {
                          return (
                            <div
                              key={indexDia}
                              className={`dia ${!diasParaUso.includes(dia) && "ativo"
                                } ${!diasParaUso.includes(dia) &&
                                !intervalo.dias.includes(dia) &&
                                "disabled"
                                }`}
                              onClick={() => {
                                if (
                                  diasParaUso.includes(dia) ||
                                  intervalo.dias.includes(dia)
                                ) {
                                  if (diasParaUso.includes(dia)) {
                                    setDiasParaUso(
                                      diasParaUso.filter(
                                        (item) => item !== dia,
                                      ),
                                    );
                                    const copia = copy(configuracoes);
                                    copia.frete.retirada_no_local.intervalos[
                                      indexIntervalo
                                    ].dias.push(dia);
                                    setConfiguracoes(copia);
                                  } else {
                                    const copiaDias = copy(diasParaUso);
                                    copiaDias.push(dia);
                                    setDiasParaUso(copiaDias);

                                    const copia = copy(configuracoes);
                                    copia.frete.retirada_no_local.intervalos[
                                      indexIntervalo
                                    ].dias.splice(
                                      copia.frete.retirada_no_local.intervalos[
                                        indexIntervalo
                                      ].dias.indexOf(dia),
                                      1,
                                    );

                                    if (
                                      copia.frete.retirada_no_local.intervalos[
                                        indexIntervalo
                                      ].dias.length === 0 &&
                                      copia.frete.retirada_no_local.intervalos
                                        .length > 1
                                    ) {
                                      copia.frete.retirada_no_local.intervalos.splice(
                                        indexIntervalo,
                                        1,
                                      );
                                    }

                                    setConfiguracoes(copia);
                                  }
                                }
                              }}
                            >
                              {dia[0].toUpperCase()}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="horariosContainer">
                      {intervalo.horarios.map((horario, indexHorario) => {
                        return (
                          <>
                            <div className="horariosFlex">
                              <div className="horarios">
                                <Input
                                  required={
                                    configuracoes.frete.retirada_no_local.ativo
                                  }
                                  label="Abre"
                                  alignLabel="center"
                                  type={"time"}
                                  value={horario.abre}
                                  placeholder={"8:00"}
                                  onChange={(newValue) => {
                                    const copia = copy(configuracoes);
                                    copia.frete.retirada_no_local.intervalos[
                                      indexIntervalo
                                    ].horarios[indexHorario].abre = newValue;
                                    setConfiguracoes(copia);
                                  }}
                                ></Input>
                                <Input
                                  required={
                                    configIn === "configuracoes" &&
                                      configuracoes.frete.retirada_no_local.ativo
                                      ? true
                                      : false
                                  }
                                  label="Fecha"
                                  alignLabel="center"
                                  type={"time"}
                                  value={horario.fecha}
                                  placeholder={"11:30"}
                                  onChange={(newValue) => {
                                    const copia = copy(configuracoes);
                                    copia.frete.retirada_no_local.intervalos[
                                      indexIntervalo
                                    ].horarios[indexHorario].fecha = newValue;
                                    setConfiguracoes(copia);
                                  }}
                                ></Input>
                                {intervalo.horarios.length > 1 && (
                                  <div
                                    className="x"
                                    onClick={() => {
                                      const copia = copy(configuracoes);
                                      copia.frete.retirada_no_local.intervalos[
                                        indexIntervalo
                                      ].horarios.splice(indexHorario, 1);
                                      setConfiguracoes(copia);
                                    }}
                                  >
                                    X
                                  </div>
                                )}
                              </div>
                            </div>
                            {intervalo.horarios.length < 2 && (
                              <div
                                className="adicionar fonteTexto"
                                onClick={() => {
                                  const copia = copy(configuracoes);
                                  copia.frete.retirada_no_local.intervalos[
                                    indexIntervalo
                                  ].horarios.push({ abre: "", fecha: "" });
                                  setConfiguracoes(copia);
                                }}
                              >
                                Adicionar outro intervalo de tempo
                              </div>
                            )}
                          </>
                        );
                      })}
                    </div>
                  </div>
                </>
              );
            },
          )}
          {configuracoes.frete.retirada_no_local.intervalos[
            configuracoes.frete.retirada_no_local.intervalos.length - 1
          ].dias.length > 0 &&
            diasParaUso.length > 0 && (
              <div
                className="adicionar fonteTexto"
                onClick={() => {
                  const copia = copy(configuracoes);
                  copia.frete.retirada_no_local.intervalos.push({
                    dias: [],
                    horarios: [{ abre: "", fecha: "" }],
                  });
                  setConfiguracoes(copia);
                }}
              >
                Adicionar outros dias e horarios
              </div>
            )}
        </div>
      </ContainerRetiradaNoLocalContainer>
    </>
  );
};

export default RetiradaNoLocal;
